module.exports = __webpack_public_path__ + "static/media/8C.873c8cc4.svg";